import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { SxErrorService } from '@services';
import { OrderForm, Fi2XmlOrderForm } from '@model';
import { ProductCategoryInformation } from 'app/models/product-category-information.model';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {
  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  getProducts(): Observable<ProductCategoryInformation> {
    return this.http
      .get<ProductCategoryInformation>(`${environment.apiEndpoint}/Products/WithInformation`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  purchaseFi2Xml(product: Fi2XmlOrderForm): Observable<boolean> {
    return this.http
      .post<boolean>(`${environment.apiEndpoint}/Products/PurchaseFi2Xml`, product)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  getIsFi2XmlRegisteredOnCustomer(customerId: string): Observable<Fi2XmlOrderForm> {
    return this.http
      .post<Fi2XmlOrderForm>(`${environment.apiEndpoint}/Products/IsFi2XmlRegisteredOnCustomer/${customerId}`, null)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }
}
